import { t } from "@lingui/macro";

import { GmProfileFragment, User } from "@/saleor/api";

export type ReplacementGetter =
	| keyof GmProfileFragment
	| ((client: GmProfileFragment, user: User) => string);

export type ReplacementItem = {
	label: string;
	getter: ReplacementGetter;
};

export const REPLACEMENT_MAP: { [key: string]: ReplacementItem } = {
	"{{ name }}": {
		label: t`Preferred name of your client`,
		getter: "name",
	},
	"{{ full_name }}": {
		label: t`Name of your client`,
		getter: "fullName",
	},
	"{{ salutation }}": {
		label: t`Salutation of your client`,
		getter: "salutation",
	},
	"{{ sales_person_name }}": {
		label: t`Your name`,
		getter: (client: GmProfileFragment, user: User) => {
			return `${user?.firstName} ${user?.lastName}`.trim();
		},
	},
};

export type AttributeValidationItem = {
	key: string;
	name: string;
};

export const PRODUCT_ATTRIBUTE_VALIDATION_META: {
	[key: string]: AttributeValidationItem;
} = {
	maxLength: {
		key: "max-length",
		name: t`Max length`,
	},
};

export const CUSTOM_DELIVERY_DATES_META = "custom-delivery-dates";
export const CUSTOM_DELIVERY_DATES_MOONCAKE_ATTR = "mooncake-delivery-period";
